import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-family: 'IBM Plex Sans';
  height: 100vh;
  font-size: 64px;
`

const Text = styled.div`
  width: 40vh;
`

const NotFound = () => (
  <Container>
    <Text>Nothing is here...</Text>
  </Container>
)

export default NotFound
